import React from 'react';
import {render} from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './styles/cotizacion.css'
import './styles/bootstrap-grid.min.css'
import { BrowserRouter } from 'react-router-dom';

import configureStore from "./redux/configureStore";
import {Provider as ReduxProvider} from 'react-redux'
import {SnackbarProvider} from 'notistack';
import {ThemeProvider} from '@material-ui/core/styles'
import theme from "./theme";
import { ZonaHorariaProvider } from './contextos/zonaHorariaContext';
import { ContactosDistribuidorProvider } from './contextos/contactosDistribuidorContext';
import { ContactosDistribuidorDestinoProvider } from './contextos/contactosDistribuidorDestinoContext';
import { AreasServiciosAllProvider } from './contextos/areasServiciosAllContext';

const initialState = window['INITIAL_REDUX_STATE'];
const store = configureStore(initialState);

render(
    <ReduxProvider store={store}>
        <SnackbarProvider maxSnack={3} anchorOrigin={{vertical: 'top', horizontal: 'right'}} autoHideDuration={5000}>
            <ThemeProvider theme={theme}>
                <React.StrictMode>
                    <ZonaHorariaProvider>
                        <ContactosDistribuidorProvider>
                            <ContactosDistribuidorDestinoProvider>
                                <AreasServiciosAllProvider>
                                    <BrowserRouter>
                                        <App/>
                                    </BrowserRouter>
                                </AreasServiciosAllProvider>
                            </ContactosDistribuidorDestinoProvider>
                        </ContactosDistribuidorProvider>
                    </ZonaHorariaProvider>
                </React.StrictMode>
            </ThemeProvider>
        </SnackbarProvider>
    </ReduxProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and obtener faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
